const pairs = [
    //{text: 'namų dekoras', url: 'https://www.lietuviskapreke.lt/k/namai-ir-interjeras/namu-dekoras?page=1&all_features=Rank%C5%B3+darbo'}, // 2
    //{text: 'rankų darbo papuošalai', url: 'https://www.lietuviskapreke.lt/g/papuosalai-ir-aksesuarai?page=1&all_features=Rank%C5%B3+darbo'}, // 1
    // { text: 'namų dekoras', url: 'https://www.lietuviskapreke.lt/g/namai-ir-gyvenimas' }, // 2
    // { text: 'rankų darbo aksesuarai', url: 'https://www.lietuviskapreke.lt/k/aksesuarai' },
    { text: 'namų dekoras', url: 'https://www.lietuviskapreke.lt/k/namai-ir-interjeras/namu-dekoras' },
    {
        text: 'rankų darbo papuošalai',
        url: 'https://www.lietuviskapreke.lt/k/papuosalai?page=1&all_features=Rank%C5%B3+darbo'
    },
    { text: 'dekoracijos namams', url: 'https://www.lietuviskapreke.lt/g/namai-ir-gyvenimas' },
    {
        text: 'rankų darbo aksesuarai',
        url: 'https://www.lietuviskapreke.lt/k/aksesuarai?page=1&all_features=Rank%C5%B3+darbo'
    }
]

function addKeywords(text, test = []) {
    if (!text) return null

    pairs.forEach(item => {
        const ucText = item.text.charAt(0).toUpperCase() + item.text.slice(1)
        let found = false
        test.forEach(testText => {
            if (testText) {
                if (testText.includes(item.text) || testText.includes(ucText)) {
                    found = true
                }
            }
        })
        if (!found) {
            if (text.includes(item.text)) {
                text = text.replace(item.text, `<a href="${item.url}">${item.text}</a>`)
            } else if (text.includes(ucText)) {
                text = text.replace(ucText, `<a href="${item.url}">${ucText}</a>`)
            }
        }
    })
    return text
}

export default addKeywords
